import { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import type {
	ClientEventValidator,
	ClientValidator,
} from '@atlassian/jira-issue-field-validation-handler/src/controllers/client-validation-handler/types.tsx';
import messages from './messages.tsx';

export const useStoryPointEstimateValidator = (): ClientEventValidator<
	number | null | undefined
> => {
	const { formatMessage } = useIntl();

	const submit: ClientValidator<number | null | undefined> = useCallback(
		(value: number | null | undefined) => {
			if (value && value < 0) {
				return {
					type: 'error',
					message: formatMessage(messages.popupStoryPointNonNegative),
				};
			}
			return null;
		},
		[formatMessage],
	);

	return { submit };
};
